/**
 * CR-8613: send a logistics company's call-off links to its own page.
 *
 * A logistics company has only the ASN tab in Purchasing, so a link to
 * `/purchasing?tab=call_off&calloff_id=…` — every haulier notice sent before
 * CR-8613, still in its bell and its email — landed it on the ASN list. This
 * forwards such a link to Logistics Call-Offs, which opens the load itself.
 */
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Forward a logistics user who arrives on Purchasing's call-off tab.
 *
 * @example useLogisticsCallOffRedirect(user?.company_type === 'logistics');
 * @param isLogistics - whether the user belongs to a logistics company
 */
export function useLogisticsCallOffRedirect(isLogistics: boolean): void {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tab = searchParams.get('tab');
  const callOffId = searchParams.get('calloff_id');

  useEffect(() => {
    if (!isLogistics || tab !== 'call_off') return;
    navigate(
      callOffId ? `/logistics/call-offs?calloff_id=${encodeURIComponent(callOffId)}` : '/logistics/call-offs',
      { replace: true },
    );
  }, [isLogistics, tab, callOffId, navigate]);
}
